// Pozycja podpowiedzi (position: fixed) względem elementu, nad którym jest kursor.
// Domyślnie wyśrodkowana pod elementem; przy krawędziach ekranu dociśnięta do marginesu,
// a gdy pod elementem brakuje miejsca - nad nim.
const MARGIN = 4
const GAP = 4

// Klasy elementu z podpowiedzią i samej podpowiedzi. Nazwana grupa (group/<nazwa>) jest potrzebna,
// gdy przodek też ma klasę `group` (np. wiersz listy) - zwykłe group-hover pokazywałoby wtedy
// podpowiedź przy najechaniu na cały przodek.
export function tooltipGroupClasses(name) {
  if (!name) return { group: "group", tip: "group-hover:block" }

  return { group: `group/${name}`, tip: `group-hover/${name}:block` }
}

// Czysta funkcja - liczy pozycję z wymiarów, bez dotykania DOM (żeby dała się przetestować).
// rect: prostokąt elementu, tip: { width, height }, viewport: { width, height }
export function fixedTooltipPosition(rect, tip, viewport) {
  const centered = rect.left + rect.width / 2 - tip.width / 2
  const maxLeft = viewport.width - tip.width - MARGIN
  const left = Math.max(Math.min(centered, maxLeft), MARGIN)

  let top = rect.bottom + GAP
  if (top + tip.height > viewport.height - MARGIN) top = rect.top - tip.height - GAP

  return { left, top }
}
